import React from 'react';
import { history } from '../store';

class MatrixList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matrixLockCounts: {},      // Per-machine locker counts by version
      matrixTotalLockCounts: {}  // Global totals for each version + overall total
    };
  }

  componentDidMount() {
    this.calculateMatrixLockCounts();
  }

  calculateMatrixLockCounts() {
    // Initialize objects; note that we no longer predefine version keys.
    const matrixLockCounts = {};
    const matrixTotalLockCounts = { total: 0 };

    // Loop through each matrix
    this.props.matrixs.forEach(matrix => {
      const versionCounts = {};

      // Loop through each Locker in the matrix
      matrix.Locker.forEach(lock => {
        const version = lock.KerongVersion || 'N/A';
        // Update the count for the version in the current matrix.
        versionCounts[version] = (versionCounts[version] || 0) + 1;
        // Update the global count for the version.
        matrixTotalLockCounts[version] = (matrixTotalLockCounts[version] || 0) + 1;
        // Increase the overall total count.
        matrixTotalLockCounts.total++;
      });

      // Store the counts for this machine using its Serial as key.
      matrixLockCounts[matrix.Serial] = versionCounts;
    });

    // Update the state.
    this.setState({ matrixLockCounts, matrixTotalLockCounts });
  }

  goTo(matrix, e) {
    const id = matrix.Machine && matrix.Machine._id ? matrix.Machine._id : matrix.Machine;
    history.push(`/machines/${id}`);
  }

  render() {
    const { matrixLockCounts, matrixTotalLockCounts } = this.state;
    
    // Build a sorted list of versions based on the keys in matrixTotalLockCounts,
    // excluding the overall "total" key.
    const versions = matrixTotalLockCounts
      ? Object.keys(matrixTotalLockCounts)
          .filter(key => key !== 'total')
          .sort((a, b) => Number(a) - Number(b))
      : [];

    const total = matrixTotalLockCounts ? matrixTotalLockCounts['total'] : 0;

    return (
      <div>
        {/* Summary stat cards */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 20 }}>
          <div style={cardStyle}>
            <div style={cardLabel}>Total Escaneados</div>
            <div style={cardValue}>{total}</div>
          </div>
          {versions.map(version => (
            <div key={version} style={cardStyle}>
              <div style={cardLabel}>V{version}</div>
              <div style={cardValue}>{matrixTotalLockCounts ? matrixTotalLockCounts[version] || 0 : 0}</div>
              <div style={cardPct}>{total ? (((matrixTotalLockCounts[version] || 0) / total) * 100).toFixed(1) + '%' : '—'}</div>
            </div>
          ))}
        </div>

        {/* Per-machine table */}
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: 'linear-gradient(135deg,#022040,#0a4080)', color: '#fff' }}>
                <th style={stickyTh}>Máquina</th>
                {versions.map(version => (
                  <th key={version} style={compactTh}>V{version}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {this.props.matrixs.map((matrix, i) => (
                <tr key={matrix.Serial} onClick={e => this.goTo(matrix, e)}
                    style={{ cursor: 'pointer', background: i % 2 === 0 ? '#fff' : '#f8fafc' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#eaf0fa'}
                    onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#f8fafc'}>
                  <td style={stickyTd}>{matrix.Serial}</td>
                  {versions.map(version => (
                    <td key={version} style={compactTd}>
                      {matrixLockCounts[matrix.Serial] ? matrixLockCounts[matrix.Serial][version] || 0 : 0}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const cardStyle = { background: '#fff', border: '1px solid #e4eaf2', borderRadius: 10, padding: '10px 16px', minWidth: 90, textAlign: 'center', boxShadow: '0 1px 4px rgba(10,64,128,0.07)' };
const cardLabel = { fontSize: 11, color: '#6b7280', fontWeight: 600, marginBottom: 2 };
const cardValue = { fontSize: 20, fontWeight: 700, color: '#022040' };
const cardPct   = { fontSize: 11, color: '#3b82f6', fontWeight: 500 };
const stickyTh  = { position: 'sticky', left: 0, background: 'linear-gradient(135deg,#022040,#0a4080)', color: '#fff', padding: '8px 10px', textAlign: 'left', whiteSpace: 'nowrap', zIndex: 2, fontSize: 11, fontWeight: 700, borderRight: '2px solid rgba(255,255,255,0.2)' };
const compactTh = { padding: '8px 10px', textAlign: 'center', whiteSpace: 'nowrap', fontSize: 11, fontWeight: 700 };
const stickyTd  = { position: 'sticky', left: 0, background: 'inherit', padding: '6px 10px', whiteSpace: 'nowrap', fontWeight: 600, color: '#022040', borderRight: '2px solid #e4eaf2', zIndex: 1 };
const compactTd = { padding: '6px 10px', textAlign: 'center', borderBottom: '1px solid #f0f4f8' };

export default MatrixList;
